import React from "react";
import "./ZoomComponentView.css";
import ZoomMtgEmbedded from "@zoomus/websdk/embedded";
import { getDecodedDataFromWebinarLink } from "../ZoomPage/ZoomUtils";
import { IWebinarTokenPayload } from "../ZoomPage/interfaces";

function ZoomComponentView() {
  const client = ZoomMtgEmbedded.createClient();
  const meetingObj: IWebinarTokenPayload = getDecodedDataFromWebinarLink(
    window.location.href
  );
  const signature = meetingObj.signature || "";
  const sdkKey = meetingObj.sdkKey || "";
  const passWord = meetingObj.passWord || "";
  const userEmail = meetingObj.userEmail || "";
  const userName = meetingObj.userName || "";
  const meetingNumber = meetingObj.webinarId || meetingObj.meetingId || "";
  const zakToken = meetingObj.zakToken || "";

  const startMeeting = () => {
    document.getElementById("zmmtg-root")?.remove();
    let meetingSDKElement = document.getElementById("meetingSDKElement");
    if (!meetingSDKElement) {
      return;
    }
    client
      .init({
        zoomAppRoot: meetingSDKElement,
        language: "en-US",
      })
      .then(() => {
        client
          .join({
            signature: signature,
            sdkKey: sdkKey,
            meetingNumber: meetingNumber,
            password: passWord,
            userName: userName,
            userEmail: userEmail,
            ...(zakToken ? { zak: zakToken } : {}),
          })
          .then(() => {
            console.log("joined succesfully");
          })
          .catch((error) => {
            console.log(error);
          });
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const handleWindowError = (ev: ErrorEvent) => {
    console.log(ev);
  };
  React.useEffect(() => {
    startMeeting();
    window.addEventListener("error", handleWindowError);
    return () => {
      window.removeEventListener("error", handleWindowError);
    };
  }, []);

  return (
    <main>
      <div id="meetingSDKElement"></div>
    </main>
  );
}

export default ZoomComponentView;
